var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStepper4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 211.686,
    height: 158.184,
    viewBox: "0 0 211.686 158.184",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7508",
    "data-name": "Group 7508",
    transform: "translate(-527.157 -418.316)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5706",
    "data-name": "Group 5706",
    transform: "translate(600.397 546.38)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5372",
    "data-name": "Rectangle 5372",
    width: 36.62,
    height: 4.408
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3442",
    "data-name": "Path 3442",
    d: "M45.167,108.4A13.563,13.563,0,0,0,31.82,119.692h-.2a22.583,22.583,0,1,1,0-45.167h2.462a13.534,13.534,0,0,0,26.694,0h22.99a13.534,13.534,0,0,0,26.694,0h2.462a27.1,27.1,0,1,0,0-54.2H94.648a13.534,13.534,0,0,0-26.694,0H49.684V2.258A2.258,2.258,0,0,0,47.426,0H2.258A2.258,2.258,0,0,0,0,2.258V38.392A2.258,2.258,0,0,0,2.258,40.65H47.426a2.258,2.258,0,0,0,2.258-2.258V24.842h18.27a13.534,13.534,0,0,0,26.694,0h18.27a22.583,22.583,0,1,1,0,45.167h-2.462a13.534,13.534,0,0,0-26.694,0H60.772a13.534,13.534,0,0,0-26.694,0H31.617a27.1,27.1,0,1,0,0,54.2h.2a13.534,13.534,0,0,0,26.694,0h4.72v-4.517h-4.72A13.563,13.563,0,0,0,45.167,108.4ZM22.584,4.517H27.1V13.55H22.584ZM45.167,36.134H4.517V4.517h13.55V15.808a2.258,2.258,0,0,0,2.258,2.258h9.033a2.258,2.258,0,0,0,2.258-2.258V4.517h13.55ZM81.3,31.617a9.033,9.033,0,1,1,9.033-9.033A9.042,9.042,0,0,1,81.3,31.617ZM97.109,63.234a9.033,9.033,0,1,1-9.033,9.033A9.042,9.042,0,0,1,97.109,63.234Zm-49.684,0a9.033,9.033,0,1,1-9.033,9.033A9.042,9.042,0,0,1,47.426,63.234Zm-2.258,67.75a9.033,9.033,0,1,1,9.033-9.033A9.042,9.042,0,0,1,45.167,130.984Z",
    transform: "translate(538.346 426.686)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5375",
    "data-name": "Rectangle 5375",
    width: 62.051,
    height: 55.947,
    transform: "translate(527.157 418.316)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3424",
    "data-name": "Path 3424",
    d: "M11230.523,20190.123l-23.951,19.639v30.633h48.363v-29.941Z",
    transform: "translate(-10569.555 -19666.395)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3423",
    "data-name": "Path 3423",
    d: "M0,0,19.066,13.629",
    transform: "matrix(-0.259, 0.966, -0.966, -0.259, 652.483, 521.694)",
    fill: "none",
    stroke: "#f37320",
    strokeLinecap: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-search-1122987",
    transform: "translate(693.831 530.518)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3871",
    "data-name": "Path 3871",
    d: "M216,46.154a15.832,15.832,0,0,0,2.827.257,15.443,15.443,0,0,0,5.658-1.071l3.25,7.354h0a5.2,5.2,0,0,0,3.36,2.909,4.428,4.428,0,0,0,.487.11h0a5.219,5.219,0,0,0,4.56-8.866l-5.718-5.635A15.627,15.627,0,1,0,216,46.154Zm19.437,4.656a2.932,2.932,0,0,1-3.452,2.624l-.276-.064a2.923,2.923,0,0,1-1.889-1.636l-3.277-7.4q.584-.336,1.145-.722t1.085-.827l5.782,5.681a2.923,2.923,0,0,1,.882,2.344ZM205.663,28.4a13.328,13.328,0,0,1,13.094-10.971,13.484,13.484,0,0,1,2.408.216,13.329,13.329,0,1,1-15.5,10.755Z",
    transform: "translate(-192.693 -15.152)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3872",
    "data-name": "Path 3872",
    d: "M85.328,104.223a1.145,1.145,0,0,0,.809.336h16.514a3.217,3.217,0,0,0,3.217-3.218v-4.5a1.149,1.149,0,1,0-2.3,0v4.486a.919.919,0,0,1-.919.919H87.824V95.026a2.688,2.688,0,0,0-2.684-2.684H77.9V68.4a.919.919,0,0,1,.919-.919H83.77a1.149,1.149,0,0,0,0-2.3H78.816A3.217,3.217,0,0,0,75.6,68.4V94.029a1.145,1.145,0,0,0,.335.809Zm.211-9.192V101.2l-6.572-6.572H85.14a.4.4,0,0,1,.4.4Z",
    transform: "translate(-75.598 -61.077)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3873",
    "data-name": "Path 3873",
    d: "M410.529,192.719a1.145,1.145,0,1,1-1.144-1.145,1.144,1.144,0,0,1,1.144,1.145",
    transform: "translate(-380.939 -177.095)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3874",
    "data-name": "Path 3874",
    d: "M295.9,192.719a1.144,1.144,0,1,1-1.145-1.145,1.144,1.144,0,0,1,1.145,1.145",
    transform: "translate(-275.721 -177.095)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3875",
    "data-name": "Path 3875",
    d: "M467.813,192.719a1.144,1.144,0,1,1-1.144-1.145,1.144,1.144,0,0,1,1.144,1.145",
    transform: "translate(-433.521 -177.095)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3876",
    "data-name": "Path 3876",
    d: "M353.189,192.719a1.145,1.145,0,1,1-1.145-1.145,1.144,1.144,0,0,1,1.145,1.145",
    transform: "translate(-328.305 -177.095)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "noun_forms_1236251",
    transform: "translate(552.256 418.316)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3398",
    "data-name": "Path 3398",
    d: "M52.373,17.963a1.068,1.068,0,0,0-.3-.748L39.815,4.721a1.068,1.068,0,0,0-.764-.321H20.622A5.342,5.342,0,0,0,15.28,9.742V47.791a5.342,5.342,0,0,0,5.342,5.342h26.41a5.342,5.342,0,0,0,5.342-5.342ZM40.034,7.984l9.236,9.423H41.636a1.6,1.6,0,0,1-1.6-1.6Zm7,43.012H20.622a3.205,3.205,0,0,1-3.205-3.205V9.726a3.205,3.205,0,0,1,3.205-3.205H37.9V15.8a3.739,3.739,0,0,0,3.739,3.739h8.6V47.791A3.205,3.205,0,0,1,47.031,51Z",
    transform: "translate(-15.28 -4.4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3399",
    "data-name": "Path 3399",
    d: "M56.014,48.26h-14.4a1.068,1.068,0,1,0,0,2.137h14.4a1.068,1.068,0,1,0,0-2.137Z",
    transform: "translate(-27.051 -24.831)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3400",
    "data-name": "Path 3400",
    d: "M29.1,47.26a1.6,1.6,0,0,0,0,3.205h.027A1.6,1.6,0,1,0,29.1,47.26Z",
    transform: "translate(-20.972 -24.365)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3401",
    "data-name": "Path 3401",
    d: "M56.014,61.26h-14.4a1.068,1.068,0,1,0,0,2.137h14.4a1.068,1.068,0,1,0,0-2.137Z",
    transform: "translate(-27.051 -30.887)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3402",
    "data-name": "Path 3402",
    d: "M29.1,60.26a1.6,1.6,0,1,0,0,3.205h.027A1.6,1.6,0,1,0,29.1,60.26Z",
    transform: "translate(-20.972 -30.421)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3403",
    "data-name": "Path 3403",
    d: "M56.014,74.26h-14.4a1.068,1.068,0,1,0,0,2.137h14.4a1.068,1.068,0,1,0,0-2.137Z",
    transform: "translate(-27.051 -36.943)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3404",
    "data-name": "Path 3404",
    d: "M29.1,73.26a1.6,1.6,0,0,0,0,3.205h.027A1.6,1.6,0,1,0,29.1,73.26Z",
    transform: "translate(-20.972 -36.477)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepper4);
export default __webpack_public_path__ + "static/media/stepper4.81328cf928b662364864b77c430af3be.svg";
export { ForwardRef as ReactComponent };